import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import HomeService from '../service.js';

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      dataList: [],
      // dataList: [],
      swiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          resize: () => {
            // this.$refs.swiper.$swiper.changeDirection(
            //   window.innerWidth <= 960 ? 'vertical' : 'horizontal'
            // );
          }
        }
      }
    };
  },
  created() {
    this.$nextTick(() => {
      HomeService.appAdvertList().then(res => {
        if (res.code === '0') {
          res.data.forEach(item => {
            this.dataList.push({ allPath: item.urls[0].url, linkurl: item.url });
          });
          if (this.dataList.length === 1) {
            this.swiperOption.loop = false;
          }
        }
      });
    });
    // this.dataList = [
    //   {
    //     allPath: require('@/assets/images/home/banner/banner_1.jpg')
    //   },
    //   {
    //     allPath: require('@/assets/images/home/banner/banner_2.jpg')
    //   },
    //   {
    //     allPath: require('@/assets/images/home/banner/banner_3.jpg')
    //   }
    // ];
    // this.$nextTick(() => {
    //   if (localStorage.pathList) {
    //     console.log(1111)
    //     this.dataList = JSON.parse(localStorage.pathList);
    //   } else {
    //     if (window.location.origin.indexOf('jlncjy.cn') >= 0 || window.location.origin.indexOf('stage') >= 0) {
    //       this.dataList = [
    //         {
    //           allPath: require('@/assets/images/home/banner/stagebanner.jpg')
    //         }
    //       ];
    //       this.swiperOption.loop = false;
    //     } else {
    //       this.dataList = [
    //         {
    //           allPath: require('@/assets/images/home/banner/banner_1.jpg')
    //         },
    //         {
    //           allPath: require('@/assets/images/home/banner/banner_2.jpg')
    //         },
    //         {
    //           allPath: require('@/assets/images/home/banner/banner_3.jpg')
    //         }
    //       ];
    //     }
    //   }
    // });
  }
};
